import { Box, Flex, Image, Text } from "@chakra-ui/react";

import { partners } from "./data";

export default function Partners() {
  return (
    <Box bgColor="rgba(240, 237, 236, 0.2)" w="full">
      <Box
        id="partners"
        py="60px"
        px={{ xl: "106px", lg: "5px", base: "16px" }}
        data-testid="partners"
        maxWidth={"1440px"}
        mx="auto"
      >
        <Box mx="auto" width={{ xl: "90%", lg: "95%" }}>
          <Text
            w="full"
            textAlign={"center"}
            textTransform={"uppercase"}
            data-testid="partners.heading"
            color="rgba(13, 48, 80, 0.8)"
            fontSize={{ lg: "18px", base: "14px" }}
            lineHeight={{ lg: "18px", base: "14px" }}
            letterSpacing={"0.05em"}
          >
            Trusted and powering benefits for companies like
          </Text>

          <Flex
            align={"center"}
            justify={{ lg: "space-between" }}
            direction={{ lg: "row", base: "column" }}
            gap={{ base: "35px" }}
            pt={"40px"}
            data-testid="partners.items"
          >
            {partners.map(({ id, name, image }) => (
              <div key={id} data-testid={`partners.items.${id}`}>
                <Image src={image} alt={name} placeholder="blur" height="34.03px" />
              </div>
            ))}
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}
